(function () {
  "use strict";
  var S = window.VENDORA_STRINGS || {};
  var T = {
    added: S.added || "Added to bag",
    add_error: S.add_error || "Sorry, that could not be added",
    saved: S.saved || "Saved to wishlist",
    add_to_cart: S.add_to_cart || "Add to bag",
    sold_out: S.sold_out || "Sold out",
    sold_out_short: S.sold_out_short || "Sold out"
  };
  var toastTimer;
  function toast(msg) {
    var t = document.getElementById("vendora-toast");
    if (!t) return;
    t.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6 9 17l-5-5"/></svg><span>' + msg + "</span>";
    requestAnimationFrame(function () { t.classList.add("show"); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove("show"); }, 2600);
  }
  window.vendoraToast = toast;
  function setBadge(count) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) { el.textContent = count; el.style.display = count > 0 ? "grid" : "none"; });
  }
  function refreshBadge() {
    fetch("/cart.js", { headers: { "Content-Type": "application/json" } }).then(function (r) { return r.json(); }).then(function (c) { setBadge(c.item_count); }).catch(function () {});
  }
  function addToCart(id, qty) {
    return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: id, quantity: qty || 1 }) })
      .then(function (r) { return r.json(); })
      .then(function (item) { refreshBadge(); toast(T.added + " \u2014 " + (item.product_title || "")); })
      .catch(function () { toast(T.add_error); });
  }
  document.addEventListener("click", function (e) {
    var quick = e.target.closest("[data-quick-add]");
    if (quick) { e.preventDefault(); var vid = quick.getAttribute("data-quick-add"); if (vid) addToCart(vid, 1); return; }
    var fav = e.target.closest(".product-fav");
    if (fav) { e.preventDefault(); toast(T.saved); }
  });
  function initNav() {
    var toggle = document.querySelector(".nav-toggle");
    var links = document.querySelector(".nav-links");
    if (toggle && links) { toggle.addEventListener("click", function () { var open = links.classList.toggle("open"); toggle.setAttribute("aria-expanded", open); }); }
  }
  function initGallery() {
    // The gallery is a snap-scrolling track. It follows the colour choice, and a
    // swipe reports back so the colour can follow the photo.
    var track = document.querySelector("[data-pdp-track]");
    if (!track) return null;
    var slides = [].slice.call(track.querySelectorAll("[data-pdp-slide]"));
    var thumbs = [].slice.call(document.querySelectorAll("[data-pdp-thumb]"));
    if (!slides.length) return null;
    var current = 0;
    var settling = null;
    var muted = false;
    var api = { onSettle: null };

    function idOf(i) { return slides[i].getAttribute("data-image-id"); }
    function indexOfId(id) {
      return slides.findIndex(function (s) { return s.getAttribute("data-image-id") === String(id); });
    }
    function mark(i) {
      current = i;
      var id = idOf(i);
      thumbs.forEach(function (t) { t.setAttribute("aria-current", t.getAttribute("data-image-id") === id ? "true" : "false"); });
    }
    function goTo(i, smooth) {
      if (i < 0 || i >= slides.length || i === current) return;
      // Muted while we drive the track, so our own scrolling doesn't read as a swipe.
      muted = true;
      slides[i].scrollIntoView({ behavior: smooth ? "smooth" : "auto", inline: "center", block: "nearest" });
      mark(i);
      clearTimeout(settling);
      settling = setTimeout(function () {
        // A smooth scroll is dropped in some states (a background tab, reduced
        // motion). Land it outright rather than leaving the wrong photo up.
        if (nearest() !== i) slides[i].scrollIntoView({ behavior: "auto", inline: "center", block: "nearest" });
        muted = false;
      }, 450);
    }
    function nearest() {
      // Measured on screen rather than from scrollLeft, which counts backwards
      // in Arabic and would pick the wrong slide.
      var box = track.getBoundingClientRect();
      var mid = box.left + box.width / 2;
      var best = 0;
      var bestGap = Infinity;
      slides.forEach(function (s, i) {
        var r = s.getBoundingClientRect();
        var gap = Math.abs(r.left + r.width / 2 - mid);
        if (gap < bestGap) { bestGap = gap; best = i; }
      });
      return best;
    }
    var scrollTimer;
    track.addEventListener("scroll", function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var i = nearest();
        if (i === current) return;
        mark(i);
        if (!muted && api.onSettle) api.onSettle(idOf(i));
      }, 120);
    }, { passive: true });
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        var id = t.getAttribute("data-image-id");
        var i = indexOfId(id);
        if (i === -1) return;
        goTo(i, true);
        if (api.onSettle) api.onSettle(id);
      });
    });
    mark(0);
    api.show = function (id) {
      if (id === null || id === undefined) return;
      var i = indexOfId(id);
      if (i !== -1) goTo(i, true);
    };
    return api;
  }

  function initProductForm() {
    var form = document.querySelector("[data-product-form]");
    if (!form) return;
    var variantInput = form.querySelector("[data-variant-id]");
    var priceEl = document.querySelector("[data-price-display]");
    var sizes = form.querySelectorAll(".size");
    var variants = JSON.parse(form.getAttribute("data-variants") || "[]");
    // Sale UI (compare-at, pill, savings) and the per-unit badge exist only when the
    // product has the data; each variant carries its own sale state.
    var priceBlock = document.querySelector("[data-price-block]");
    var unitEl = document.querySelector("[data-unit-price]");
    function reveal(el, on, html) {
      if (!el) return;
      if (on && html) el.innerHTML = html;
      el.hidden = !on;
    }
    var gallery = initGallery();
    function showImage(url, alt, id) {
      if (gallery) { gallery.show(id); return; }
      var stageImg = document.querySelector("[data-pdp-stage] img");
      if (!stageImg || !url || stageImg.getAttribute("src") === url) return;
      stageImg.removeAttribute("srcset");
      stageImg.removeAttribute("sizes");
      stageImg.setAttribute("src", url);
      stageImg.setAttribute("alt", alt || "");
    }
    function applyVariant(v) {
      var addBtn = form.querySelector("[data-add]");
      if (!v) {
        // No such colour and size together — nothing to add to the bag.
        variantInput.value = "";
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = T.sold_out; }
        return;
      }
      variantInput.value = v.id;
      if (priceEl) priceEl.innerHTML = v.price_html;
      if (priceBlock) {
        reveal(priceBlock.querySelector("[data-compare]"), !!v.on_sale, v.compare_html);
        reveal(priceBlock.querySelector("[data-sale-pill]"), !!(v.on_sale && v.pill_text), v.pill_text);
        reveal(priceBlock.querySelector("[data-saving]"), !!v.on_sale, v.saving_html);
      }
      if (unitEl && v.unit_html) unitEl.innerHTML = v.unit_html;
      if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? T.add_to_cart : T.sold_out; }
      showImage(v.image, v.image_alt, v.image_id);
    }
    function selectVariant(id) {
      applyVariant(variants.find(function (x) { return String(x.id) === String(id); }));
    }

    var colorRow = form.querySelector(".color-row[data-option-index]");
    var selects = form.querySelectorAll("select[data-option-index]");
    if (colorRow && selects.length) {
      // Colour and size are picked separately: the dropdowns only offer what the
      // chosen colour actually has.
      var colorIndex = parseInt(colorRow.getAttribute("data-option-index"), 10);
      var colorBtns = colorRow.querySelectorAll("[data-option-value]");
      var selection = [];
      var startId = variantInput.value;
      var start = variants.find(function (x) { return String(x.id) === String(startId); }) || variants[0];
      if (start) selection = start.options.slice();

      function matches(v, upTo) {
        for (var i = 0; i < upTo; i++) { if (v.options[i] !== selection[i]) return false; }
        return true;
      }
      function refresh() {
        selects.forEach(function (sel) {
          var idx = parseInt(sel.getAttribute("data-option-index"), 10);
          var seen = [];
          variants.forEach(function (v) {
            if (matches(v, idx) && seen.indexOf(v.options[idx]) === -1) seen.push(v.options[idx]);
          });
          if (!seen.length) return;
          if (seen.indexOf(selection[idx]) === -1) selection[idx] = seen[0];
          sel.innerHTML = "";
          seen.forEach(function (name) {
            var opt = document.createElement("option");
            opt.value = name;
            var sold = !variants.some(function (v) {
              return v.available && v.options[idx] === name && matches(v, idx);
            });
            opt.textContent = sold ? name + " — " + T.sold_out_short : name;
            opt.disabled = sold;
            if (name === selection[idx]) opt.selected = true;
            sel.appendChild(opt);
          });
        });
        colorBtns.forEach(function (b) {
          b.setAttribute("aria-pressed", b.getAttribute("data-option-value") === selection[colorIndex] ? "true" : "false");
        });
        // The circles carry no text, so the chosen colour is named by the label.
        var nameEl = form.querySelector("[data-option-selected]");
        if (nameEl) nameEl.textContent = selection[colorIndex] || "";
        applyVariant(variants.find(function (v) {
          return v.options.every(function (o, i) { return o === selection[i]; });
        }));
      }
      colorBtns.forEach(function (btn) {
        btn.addEventListener("click", function () {
          selection[colorIndex] = btn.getAttribute("data-option-value");
          refresh();
          showImage(btn.getAttribute("data-variant-image"), btn.getAttribute("data-variant-alt"), btn.getAttribute("data-image-id"));
        });
      });
      selects.forEach(function (sel) {
        sel.addEventListener("change", function () {
          selection[parseInt(sel.getAttribute("data-option-index"), 10)] = sel.value;
          refresh();
        });
      });
      if (gallery) {
        // Swiping to another colour's photo moves the colour choice with it.
        gallery.onSettle = function (imageId) {
          var v = variants.find(function (x) { return String(x.image_id) === String(imageId); });
          if (!v || selection[colorIndex] === v.options[colorIndex]) return;
          selection[colorIndex] = v.options[colorIndex];
          refresh();
        };
      }
      refresh();
    } else {
      sizes.forEach(function (btn) { btn.addEventListener("click", function () { sizes.forEach(function (s) { s.setAttribute("aria-pressed", s === btn); }); selectVariant(btn.getAttribute("data-variant")); }); });
      if (gallery) {
        gallery.onSettle = function (imageId) {
          var v = variants.find(function (x) { return String(x.image_id) === String(imageId); });
          if (!v || String(v.id) === String(variantInput.value)) return;
          sizes.forEach(function (s) { s.setAttribute("aria-pressed", s.getAttribute("data-variant") === String(v.id) ? "true" : "false"); });
          selectVariant(v.id);
        };
      }
    }
    var qtyInput = form.querySelector("[data-qty]");
    form.querySelectorAll("[data-qty-step]").forEach(function (b) { b.addEventListener("click", function () { var step = parseInt(b.getAttribute("data-qty-step"), 10); var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + step); qtyInput.value = Math.min(10, v); }); });
    form.addEventListener("submit", function (e) { e.preventDefault(); addToCart(variantInput.value, parseInt(qtyInput.value, 10) || 1); });
  }
  function initHeroSlider() {
    var slider = document.querySelector("[data-hero-slider]");
    if (!slider) return;
    var slides = slider.querySelectorAll("[data-hero-slide]");
    var dots = slider.querySelectorAll("[data-hero-dot]");
    if (slides.length < 2) return;
    var i = 0; var timer;
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var interval = (parseInt(slider.getAttribute("data-interval"), 10) || 5) * 1000;
    function go(n) { slides[i].classList.remove("active"); if (dots[i]) dots[i].classList.remove("active"); i = (n + slides.length) % slides.length; slides[i].classList.add("active"); if (dots[i]) dots[i].classList.add("active"); }
    function start() { if (!reduce) timer = setInterval(function () { go(i + 1); }, interval); }
    function stop() { clearInterval(timer); }
    dots.forEach(function (dot) { dot.addEventListener("click", function () { stop(); go(parseInt(dot.getAttribute("data-hero-dot"), 10)); start(); }); });
    slider.addEventListener("mouseenter", stop);
    slider.addEventListener("mouseleave", start);
    start();
  }
  document.addEventListener("DOMContentLoaded", function () { refreshBadge(); initNav(); initProductForm(); initHeroSlider(); });
})();
